export default __webpack_public_path__ + "static/N0198-fa92374a7419ef33ce005be01903980a.png";